// ControlLayout — category-based two-panel layout for control routes.
// Delegates to the shared CategoryLayout component.

import { CategoryLayout, useSelectedCategory } from '@/components/features/category-selection-tree'

export { useSelectedCategory }

export function ControlLayout() {
  return (
    <CategoryLayout
      categoryType="control"
      domainPath="controls"
      heading="Control Categories"
    />
  )
}
